import debounce from '../scripts/debounce';

const THRESHOLD = 300;
const $paginationElem = $('.pagination');
const $window = $(window);
const $document = $(document);
const paginationUrl = $paginationElem.attr('data-pagination-endpoint');
const pagesAmount = $paginationElem.attr('data-pagination-pages');
const pageTab = $paginationElem.attr('data-page-tab');
let currentPage = 1;
let baseEndpoint;

/* combine the existing query params with the new params for async pagination */
baseEndpoint = paginationUrl + (window.location.search ? window.location.search + `&partial=true&page=` : '?partial=true&page=');

/* initialize pagination */
$paginationElem.hide()
let isPaginating = false

const processScroll = debounce( () => infiniteload(), 100 )

/* listen to scrolling */
$window.on('scroll', processScroll);

const infiniteload = () => {
  if (!isPaginating && currentPage < pagesAmount && $window.scrollTop() > $document.height() - $window.height() - THRESHOLD) {
    isPaginating = true;
    currentPage++;

    $paginationElem.removeClass('d-none').addClass('d-flex');

    $.ajax({
      url: baseEndpoint + currentPage
    }).done(function (result) {
      $('.js-items-container').append(result);
      isPaginating = false;
    });
  }

  if (currentPage >= pagesAmount) {
    $paginationElem.removeClass('d-flex').addClass('d-none');
  }
};